import PropTypes from 'prop-types';
import React from 'react';


export default function PageEstablishmentSection({ className, children, image }) {
  return (
    <div className={ `page-establishment-cta ${className}` }>
      { image
        && (
          <div className="page-establishment-cta__image">
            <img alt="" className="page-establishment-cta__image__item" src={ image } />
          </div>
        )
      }
      { children }
    </div>
  );
}

PageEstablishmentSection.defaultProps = {
  children: null,
  className: '',
  image: null,
};

PageEstablishmentSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  image: PropTypes.string,
};
